import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import SurveyListApiRequest from "../request/SurveyQuestionnaireResponsesApiRequest";
import SurveyQuestionnaireResponse from "../model/SurveyQuestionnaireResponse";

const SurveyQuestionnaireResponseApiService = async (
  request: SurveyListApiRequest): Promise<SurveyQuestionnaireResponse> => {
  const url = `/formquestionresponses/`;
  const { data } = await axios.get(url, {
    params: request
  });
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useSurveyQuestionnaireResponseApiService = (
  request: SurveyListApiRequest
) => useQuery<Promise<SurveyQuestionnaireResponse>, AxiosError, SurveyQuestionnaireResponse>(
  [
    "SurveyQuestionnaireResponsesApiService",
    request.form_question_id,
    request.page
  ], () =>
    SurveyQuestionnaireResponseApiService(request)
);

export default useSurveyQuestionnaireResponseApiService;